import { URITypeMap } from '../enums/uri_type';
import { createURI } from '../uri';
export function unknownURI(args) {
    return createURI(URITypeMap.UNKNOWN, {
        args: args !== null && args !== void 0 ? args : [],
    });
}
//# sourceMappingURL=factories.js.map